import React, { Component } from 'react'
// import * as ReactBootstrap from 'react-bootstrap';
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'
import { withTranslation } from 'react-i18next'
import paymentIcon from '../../assets/images/payment/payment.png'
import transportationIcon from '../../assets/images/payment/transportation.png'

const styles = () => {
  return {
    container: {
      width: 'auto',
      position: 'relative',
      backgroundColor: 'white',
      borderRadius: '20px',
      boxShadow: '0 3px 3px #D2D2D2',
      height: '100px',
      display: 'flex',
      alignItems: 'center',
    },
    right: {
      float: 'right',
      width: '50%',
    },
    left: {
      float: 'left',
      width: '50%',
    },
    imageContainer: {
      width: '40px',
      height: '40px',
      paddingLeft: '50%',
    },
    image: {
      width: '40px',
      height: '40px',
      transform: 'translateX(-50%)',
    },
    content: {
      minHeight: 'auto',
      height: 'auto',
    },
    money: {
      fontSize: '16px',
      fontWeight: '600',
      textAlign: 'center',
    },
    meaning: {
      paddingTop: '3px',
      color: 'grey',
      fontSize: '11px',
      textAlign: 'center',
    },
    verticalLine: {
      width: '2px',
      height: '7vh',
      background: '#E0E0E0',
    },
  }
}
@withTranslation()
@injectSheet(styles)
class DividedWhiteBox extends Component {
  render() {
    const {
      balance, total, classes, t,
    } = this.props
    return (
      <div className={classes.container}>
        <div className={classes.left}>
          <div className={classes.imageContainer}>
            <img className={classes.image} src={paymentIcon} alt="" />
          </div>
          <div className={classes.content}>
            <div className={classes.money}>{balance}</div>
            <div className={classes.meaning}>{t('my_balance')}</div>
          </div>
        </div>
        <div className={classes.verticalLine}>&nbsp;</div>
        <div className={classes.right}>
          <div className={classes.imageContainer}>
            <img className={classes.image} src={transportationIcon} alt="" />
          </div>
          <div className={classes.content}>
            <div className={classes.money}>{total}</div>
            <div className={classes.meaning}>{t('payment')}</div>
          </div>
        </div>
      </div>
    )
  }
}

DividedWhiteBox.propTypes = {
  classes: PropTypes.object,
  balance: PropTypes.string,
  total: PropTypes.string,
  t: PropTypes.func,
}

export default DividedWhiteBox
